import { render } from "./component_wrapper.vue?vue&type=template&id=3e6165be&scoped=true"
import script from "./component_wrapper.vue?vue&type=script&lang=js"
export * from "./component_wrapper.vue?vue&type=script&lang=js"

import "./component_wrapper.vue?vue&type=style&index=0&id=3e6165be&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e6165be"]])

export default __exports__